/** Requests Escape on the topmost open MUI dialog so its normal close guard runs. */
export function closeTopmostDialogOnBack(doc: Document): boolean {
    const dialogs = Array.from(
        doc.querySelectorAll<HTMLElement>('[role="dialog"][aria-modal="true"]'),
    );
    const topmost = dialogs.reverse().find((dialog) => !dialog.closest('[aria-hidden="true"]'));
    const modalRoot = topmost?.closest<HTMLElement>(".MuiModal-root");
    if (!modalRoot) return false;

    modalRoot.dispatchEvent(new KeyboardEvent("keydown", {
        key: "Escape",
        code: "Escape",
        bubbles: true,
        cancelable: true,
    }));
    return true;
}
